export const CURRENT_MEMBERS_ACTIVITIES_EVENT_ID = 'CURRENT_MEMBERS_ACTIVITIES_EVENT_ID'
export const CURRENT_MEMBERS_ACTIVITIES_EVENT_NAME = 'CURRENT_MEMBERS_ACTIVITIES_EVENT_NAME'